module.exports = __webpack_public_path__ + "static/04-e651c10a889d32e8b1ec059c957f9e82.jpg";